export enum PLAUSIBLE_EVENTS {
  LOGIN = 'Login',
  SUBSCRIBE = 'Subscribe',
}
